import type { ComponentProps } from 'react'

// Unstyled on purpose — rows exist for the namespace API and as the future
// styling home; callers pass className directly.
export const Row = (props: ComponentProps<'tr'>) => <tr {...props} />
